import { classes } from '../base/classes.helpers';
import { pileBase, pileSprinkles } from './pile.css';

/**
 * Pile children on top of each other so that they take overlapping space.
 */
export const pile = (props: Parameters<typeof pileSprinkles>[0]) => {
	return classes(pileBase, pileSprinkles(props));
};
